import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToVolumeTap = (
    volumeTap$: Observable<void>,
    volumeStore: IVolumeStore
): Subscription =>
    volumeTap$
        .subscribe(() =>
            volumeStore.value.isMutedOrForceMuted ?
                volumeStore.actions.unMute() :
                volumeStore.actions.mute()
        );

export default subscribeToVolumeTap;